module.exports = __webpack_public_path__ + "static/media/0.cdb00f1c.jpg";